import { RefreshCw } from 'lucide-react'

interface LoaderProps {
  message?: string
}

export function Loader({ message = 'Cargando...' }: LoaderProps) {
  return (
    <div className="flex items-center justify-center gap-3 rounded-xl border border-border-secondary bg-bg-primary py-16 text-text-tertiary shadow-sm">
      <RefreshCw size={18} className="animate-spin" />
      <span className="text-sm">{message}</span>
    </div>
  )
}
